<template>
<b-navbar toggleable="lg" type="dark" variant="dark" variants="info">
  <b-navbar-brand :to="{name: 'home'}">{{ sitename }}</b-navbar-brand>

  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

  <b-collapse id="nav-collapse" is-nav>
    <b-navbar-nav>
      <b-nav-item
        v-for="item in menuItems"
        :key="item.route.name"
        :to="item.route"
        class="header-menu-item"
      >
        {{item.title}}
      </b-nav-item>

      <b-nav-item-dropdown text="Other">
        <b-dropdown-item
          v-for="item in otherItems"
          :key="item.route.name"
          :to="item.route"
        >
          {{item.title}}
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-navbar-nav class="ml-auto">
      <insider-version/>
      <b-nav-item-dropdown right>
        <template v-slot:button-content>
          {{user.firstName}}
        </template>
        <b-dropdown-item :to="{name: 'user_info', params: {userId: user.id}}">Profile</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="logout">Log out</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

  </b-collapse>
</b-navbar>
</template>

<script>
import auth from '../auth';
import InsiderVersion from './InsiderVersion2';
import { mayManagePushNotifications as utilMayManagePushNotifications } from '../util';

import { MAIN_SEQUENCE_PROTO_ID             } from '../model/m3level.js';
import { mayReadM3Stat as utilMayReadM3Stat } from '../model/m3level.js';

export default {
  name: 'Header',

  components: {
    InsiderVersion,
  },

  data() {
    return {
      sitename: 'Insider',
      user: auth.getViewer(),
    }
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Players',
          route: {name: 'players'},
        },
        {
          title: 'Billing',
          route: {name: 'billing'},
        }
      ];

      {
        const mayManagePushNotifications = utilMayManagePushNotifications(this.user.role);
        if(mayManagePushNotifications) {
          items.push({
            title: 'Pushes',
            route: {name: 'pushes'},
          });
        }
      }

      items.push({
        title: 'Clubs',
        route: {name: 'clubs'},
      });

      items.push({
        title: 'Contests',
        route: {name: 'contests'},
      });

      items.push({
        title: 'Game events',
        route: {name: 'gvnts'},
      });

      items.push({
        title: 'Seasons',
        route: {name: 'seasons'},
      });

      items.push({
        title: 'Update Offers',
        route: {name: 'update_offers'}
      });

      {
        const mayReadM3Stat = utilMayReadM3Stat(this.user.role);
        if(mayReadM3Stat) {

          const sequenceQuery = {
            start_level: 1,
            end_level: 50,
          };

          items.push(
            {
              title: 'M3 Levels',
              route: {name: 'sequence_levels', params: {sequence_id: MAIN_SEQUENCE_PROTO_ID}, query: sequenceQuery},
            }
          );
        }
      }

      //items.push(
      //  {
      //    title: 'M3 Levels (blocks)',
      //    route: {name: 'sequences_blocks'},
      //  }
      //);

      return items;
    },

    otherItems() {
      const items = [];

      items.push({
        title: 'Users',
        route: {name: 'users'},
      });

      items.push({
        title: 'System',
        route: {name: 'system'},
      });

      items.push({
        title: 'Daily quests',
        route: {name: 'daily_quests_timetable'},
      });

      items.push({
        title: 'Rushes',
        route: {name: 'rushes'},
      });

      items.push({
        title: 'Derbies',
        route: {name: 'derby_list'},
      });

      items.push({
        title: 'Regattas',
        route: {name: 'regatta_list'},
      });

      items.push({
        title: 'Mesas',
        route: {name: 'mesas'},
      });

      items.push({
          title: 'River rumble',
          route: {name: 'river_rumble_timetable'},
      });

      items.push({
        title: 'M3 Replays',
        route: {name: 'm3_replays'},
      });

      items.push({
        title: 'Events',
        route: {name: 'events'},
      });

      return items;
    },
  },

  methods: {
    logout() {
      auth.logout(
        onLogoutResponse.bind(this)
      );

      function onLogoutResponse(e) {
        if(e !== null) {
          this.$router.push({name: "error"});
          return;
        }

        this.$router.push({name: "login"});
      }
    },
  }
}
</script>

<style scoped>
  .header-menu-item {
    white-space: nowrap;
  }
</style>
